import { render, staticRenderFns } from "./edit_company.vue?vue&type=template&id=fa8d10ec&scoped=true&"
import script from "./edit_company.vue?vue&type=script&lang=js&"
export * from "./edit_company.vue?vue&type=script&lang=js&"
import style0 from "./edit_company.vue?vue&type=style&index=0&id=fa8d10ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8d10ec",
  null
  
)

export default component.exports